<script>
export default {
  name: "ProjectsLine"
}
</script>

<template>
  <div class="projects-imgs left flex-x-center">
    <h1 class="left flex flex-x-center">Готовые проекты</h1>
    <svg class="yellow_projects_svg" preserveAspectRatio="none" width="1920" height="300" viewBox="0 0 1920 300" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M-2 154.176C86.3102 -23.1029 346.321 -9.17214 482 59.3013C617.679 127.775 629.892 267.074 924 279.012C1218.11 290.949 1527.57 -78.0536 1964 288" stroke="#FFE866" stroke-width="24" stroke-miterlimit="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

    <div class="photos-project left flex flex-column">
      <!-- Верхний ряд -->
      <div class="project-line top-row left flex">
        <!-- Основные изображения -->
        <div class="project-container-img left flex flex-xy-center">
          <img src="/assets/image/review/review21.jpeg" alt="project-image-1">
        </div>
        <div class="project-container-img left flex flex-xy-center">
          <img src="/assets/image/review/review22.jpeg" alt="project-image-2">
        </div>
        <div class="project-container-img left flex flex-xy-center">
          <img src="/assets/image/review/review3.jpeg" alt="project-image-3">
        </div>
        <div class="project-container-img left flex flex-xy-center">
          <img src="/assets/image/review/review20.jpeg" alt="project-image-1">
        </div>
        <div class="project-container-img left flex flex-xy-center">
          <img src="/assets/image/review/review5.jpeg" alt="project-image-1">
        </div>
        <div class="project-container-img left flex flex-xy-center">
          <img src="/assets/image/review/review7.jpeg" alt="project-image-1">
        </div>
        <!-- Дубликаты изображений -->
        <div class="project-container-img left flex flex-xy-center">
          <img src="/assets/image/review/review21.jpeg" alt="project-image-1">
        </div>
        <div class="project-container-img left flex flex-xy-center">
          <img src="/assets/image/review/review22.jpeg" alt="project-image-2">
        </div>
        <div class="project-container-img left flex flex-xy-center">
          <img src="/assets/image/review/review3.jpeg" alt="project-image-3">
        </div>
        <div class="project-container-img left flex flex-xy-center">
          <img src="/assets/image/review/review20.jpeg" alt="project-image-1">
        </div>
        <div class="project-container-img left flex flex-xy-center">
          <img src="/assets/image/review/review5.jpeg" alt="project-image-1">
        </div>
        <div class="project-container-img left flex flex-xy-center">
          <img src="/assets/image/review/review7.jpeg" alt="project-image-1">
        </div>
      </div>

      <!-- Средний ряд -->
      <div class="project-line middle-row left flex">
        <!-- Основные изображения -->
        <div class="project-container-img left flex flex-xy-center">
          <img src="/assets/image/review/review8.jpeg" alt="project-image-1">
        </div>
        <div class="project-container-img left flex flex-xy-center">
          <img src="/assets/image/review/review9.jpeg" alt="project-image-2">
        </div>
        <div class="project-container-img left flex flex-xy-center">
          <img src="/assets/image/review/review10.jpeg" alt="project-image-5">
        </div>
        <div class="project-container-img left flex flex-xy-center">
          <img src="/assets/image/review/review33.jpeg" alt="project-image-5">
        </div>
        <div class="project-container-img left flex flex-xy-center">
          <img src="/assets/image/review/review34.jpeg" alt="project-image-1">
        </div>
        <div class="project-container-img left flex flex-xy-center">
          <img src="/assets/image/review/review28.jpeg" alt="project-image-4">
        </div>
        <!-- Дубликаты изображений -->
        <div class="project-container-img left flex flex-xy-center">
          <img src="/assets/image/review/review8.jpeg" alt="project-image-1">
        </div>
        <div class="project-container-img left flex flex-xy-center">
          <img src="/assets/image/review/review9.jpeg" alt="project-image-2">
        </div>
        <div class="project-container-img left flex flex-xy-center">
          <img src="/assets/image/review/review10.jpeg" alt="project-image-5">
        </div>
        <div class="project-container-img left flex flex-xy-center">
          <img src="/assets/image/review/review33.jpeg" alt="project-image-5">
        </div>
        <div class="project-container-img left flex flex-xy-center">
          <img src="/assets/image/review/review34.jpeg" alt="project-image-1">
        </div>
        <div class="project-container-img left flex flex-xy-center">
          <img src="/assets/image/review/review28.jpeg" alt="project-image-4">
        </div>
      </div>

      <!-- Нижний ряд -->
      <div class="project-line bottom-row left flex">
        <!-- Основные изображения -->

        <div class="project-container-img left flex flex-xy-center">
          <img src="/assets/image/review/review14.jpeg" alt="project-image-4">
        </div>
        <div class="project-container-img left flex flex-xy-center">
          <img src="/assets/image/review/review30.jpeg" alt="project-image-4">
        </div>
        <div class="project-container-img left flex flex-xy-center">
          <img src="/assets/image/review/review31.jpeg" alt="project-image-4">
        </div>
        <div class="project-container-img left flex flex-xy-center">
          <img src="/assets/image/review/review17.jpeg" alt="project-image-4">
        </div>
        <div class="project-container-img left flex flex-xy-center">
          <img src="/assets/image/review/review18.jpeg" alt="project-image-4">
        </div>
        <div class="project-container-img left flex flex-xy-center">
          <img src="/assets/image/review/review19.jpeg" alt="project-image-4">
        </div>
        <!-- Дубликаты изображений -->

        <div class="project-container-img left flex flex-xy-center">
          <img src="/assets/image/review/review14.jpeg" alt="project-image-4">
        </div>
        <div class="project-container-img left flex flex-xy-center">
          <img src="/assets/image/review/review30.jpeg" alt="project-image-4">
        </div>
        <div class="project-container-img left flex flex-xy-center">
          <img src="/assets/image/review/review31.jpeg" alt="project-image-4">
        </div>
        <div class="project-container-img left flex flex-xy-center">
          <img src="/assets/image/review/review17.jpeg" alt="project-image-4">
        </div>
        <div class="project-container-img left flex flex-xy-center">
          <img src="/assets/image/review/review18.jpeg" alt="project-image-4">
        </div>
        <div class="project-container-img left flex flex-xy-center">
          <img src="/assets/image/review/review19.jpeg" alt="project-image-4">
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>